module.exports = __webpack_public_path__ + "static/media/BriberyVideo.524e0d7c.mp4";